export enum ResponseType {
	Text = 'text',
	ReplyList = 'reply_list',
	QuickReplies = 'quick_replies',
	FashionAssistant = 'fashionAssistant',
}

export interface InitResponse {
	status: string
	sessionId: string
	iceBreakers?: string[]
}

export enum ConversationTrigger {
	TimeoutConversation = 'timeoutConversation_trigger',
	EndConversation = 'agentEndConversation_trigger',
	RegenerateSearch = 'fashionAssistantRegenerateSearch',
}

export interface QuickRepliesResponse {
	type: ResponseType.QuickReplies
	responses: {
		elements: {
			response: string
			payload: string
			title: string
			type?: string
		}[]
		isSurvey: true
		channel: 'chat'
	}[]
}

type ProductInfo = {
	productId: string
	color: string
}

export interface ReplyOrderListResponse {
	responses: {
		category: string
		elements: {
			title: string
			totalPrice: string
			purchaseDate: string
			products: ProductInfo[]
		}[]
	}[]
	type: ResponseType.ReplyList
}

export type RecommendedProductResponse = {
	productId: string
	name: string
	images: { main: string }
	url: string
	color: {
		id: string
		label: string
		moreColors: boolean
	}
}

export type FashionAssistantResponse = {
	responses: {
		category: string
		recommendations:
			| RecommendedProductResponse[][]
			| RecommendedProductResponse[]
	}[]
	type: ResponseType.FashionAssistant
}

export interface CountryIsoTextResponse {
	responses: { text: string }[]
	type: ResponseType.Text
}

export type AIResponse =
	| CountryIsoTextResponse
	| ReplyOrderListResponse
	| QuickRepliesResponse
	| FashionAssistantResponse

export interface PullingTextPayload {
	type: ResponseType.Text
	responses: { channel: string; text: string; agentName: string }[]
}
export interface PullingLeaveQueuePayload {
	type: ResponseType.QuickReplies
	responses: { elements: { title: string }[] }[]
}
export interface MessagePullingResponse {
	queryResult: {
		fulfillmentMessages: {
			payload: PullingTextPayload | PullingLeaveQueuePayload
		}[]
	}
	info: {
		agentAvailable?: boolean
		operator?: boolean
		action?: 'established' | 'end' | 'queue'
	}
}
